import getters from './getters';
import mutations from './mutations';
import actions from './actions';

const state = {

};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/registration/index.js